// src/components/results/InsightCards.tsx
import { motion } from 'framer-motion'
import type { Insight } from '../../lib/insights'

interface InsightCardsProps {
  insights: Insight[]
}

export function InsightCards({ insights }: InsightCardsProps) {
  if (insights.length === 0) return null

  return (
    <section aria-label="Your Key Insights">
      <span style={{
        fontFamily: 'var(--th-mono)',
        fontSize: '10.5px',
        fontWeight: 500,
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color: 'var(--th-muted)',
        display: 'block',
        marginBottom: '10px',
      }}>
        Key Findings
      </span>
      <h3 style={{
        fontFamily: 'var(--th-serif)',
        fontWeight: 400,
        fontSize: '32px',
        lineHeight: 1.1,
        letterSpacing: '-0.02em',
        color: 'var(--th-ink)',
        marginBottom: '8px',
      }}>
        Your {insights.length} Key Insights
      </h3>
      <p style={{
        fontFamily: 'var(--font-sans)',
        fontSize: '13px',
        color: 'var(--th-muted)',
        lineHeight: 1.6,
        marginBottom: '20px',
      }}>
        Drawn from your highest-signal responses.
      </p>

      {/* Rows separated by dashed rules — like .voice-col li pattern */}
      <div>
        {insights.map((insight, idx) => (
          <motion.div
            key={insight.questionId + idx}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.08 + 0.1 }}
            style={{
              display: 'grid',
              gridTemplateColumns: '40px 1fr',
              gap: '16px',
              padding: '16px 0',
              borderTop: idx === 0
                ? '1px solid var(--th-ink)'
                : '1px dashed var(--th-rule)',
            }}
          >
            {/* Index */}
            <div style={{
              fontFamily: 'var(--th-mono)',
              fontSize: '10px',
              letterSpacing: '0.1em',
              color: 'var(--th-muted)',
              fontWeight: 500,
              paddingTop: '3px',
            }}>
              {String(idx + 1).padStart(2, '0')}
            </div>

            {/* Content */}
            <div>
              <h4 style={{
                fontFamily: 'var(--th-serif)',
                fontWeight: 300,
                fontSize: '19px',
                lineHeight: 1.35,
                letterSpacing: '-0.01em',
                color: 'var(--th-ink)',
                marginBottom: '4px',
              }}>
                {insight.title}
              </h4>
              <p style={{
                fontFamily: 'var(--font-sans)',
                fontSize: '13px',
                color: 'var(--th-muted)',
                lineHeight: 1.7,
              }}>
                {insight.body}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  )
}
